import { useSupabaseLoader } from "../../../../server/supabase/hooks";
import { isChatChannel, type ChannelName } from "../../../channels/types";
import { SupabaseRecipientService } from "../../../recipients/server/supabase-recipient-service";

export type ChatChannelRecipient = {
  channel_id: string;
  display: string | null;
};

export function useChatChannelRecipients(
  channelName: ChannelName,
): ReturnType<typeof useSupabaseLoader<ChatChannelRecipient[]>> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      if (!isChatChannel(channelName)) {
        return [];
      }

      const { data, error } = await new SupabaseRecipientService(supabase).getForChannel(
        account_id,
        channelName,
        true,
      );

      if (error) {
        throw error;
      }

      return data.map((r) => ({
        channel_id: r.destination,
        display: r.display || null,
      }));
    },
    [channelName],
  );
}
